import { Component, ViewChild, OnInit } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { environment } from 'src/app/environments/environments';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { MdbTableDirective } from 'mdb-angular-ui-kit/table';
import { MdbChipAddEvent } from 'mdb-angular-ui-kit/chips';

import { take } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { PdfWatermarkService } from 'src/app/pdf-watermark.service';
import { Router } from '@angular/router';

import { DataDocumentService } from 'src/app/services/data-document.service';
import {
  Documentos,
  Tag,
  TipoDocumento,
} from '../../../../models/interfaces.model';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css'],
})
export class DocumentsComponent {
  documentList: any[] = [];

  @ViewChild('table') table!: MdbTableDirective<Documentos>;

  editElementIndex = -1;
  addRow = false;
  sort = false;
  dataSource: Documentos[] = [];
  tags: Tag[] = [];
  pdfPathToOpen: string | null = null;
  loading = false;
  isLoading = false;
  form: FormGroup;
  TipoDocumentoId = -1;
  TipoDocumento: TipoDocumento[] = [];
  DetalleTipoDocumento: TipoDocumento[] = [];
  idTipoDocumento: string | undefined;
  IdDetalleTipoDocumento = -1;
  NOMBRE_TIPO_DOCUMENTO: string | undefined;
  qty = -1;
  Results = false;
  secondaryColor = '#567ba0';
  filas = 0;
  busqueda = false;
  loadingFull = false;
  formGroup: any;
  procedureData: TipoDocumento[] = [];
  enableButton: boolean = false;

  headers = [
    {
      label: 'Codigo Documento',
      field: 'NOMBRE_DOCUMENTO',
      disableSort: false,
    },
    {
      label: 'Nombre Documento',
      field: 'CODIGO_DOCUMENTO',
      disableSort: false,
    },
    {
      label: 'Gerencia Documento',
      field: 'GERENCIA_DOCUMENTO',
      disableSort: false,
    },
    // { label: 'Palabra Claves', field: 'PALABRAS_CLAVES', disableSort: false },
  ];
  
  AllTipoDocumento:
    | { value: any; label: any; NOMBRE_TIPO_DOCUMENTO: any; PARENT: any }[]
    | undefined;

  constructor(
    private http: HttpClient,
    private watermarkService: PdfWatermarkService,
    private router: Router,
    public dataDocumentService: DataDocumentService,

    private formBuilder: FormBuilder,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer
  ) 
  {
    this.form = this.formBuilder.group({
      TipoDocumento: ['', Validators.required],
      DetalleTipoDocumento: ['', Validators.required],
    });

    this.formGroup = this.formBuilder.group({
      DetalleTipoDocumento: new FormControl(null),
    });
  }

  futureDates = new Date(new Date().setHours(0, 0, 0, 0));
  searchResults: any[] = [];

  openPdfWithWatermark(pdfPath: string): void {
    // Navega a la vista del visor de PDF y pasa la URL del PDF como parámetro
    this.router.navigate(['/pdf-viewer'], { queryParams: { url: pdfPath } });
  }

  openPDF(rutaPDF: string) {
    window.open(rutaPDF, '_blank');
  }

  imprimirPDF() {
    const iframe = document.getElementById('pdfFrame') as HTMLIFrameElement;

    if (iframe) {
      // Obtén el contenido del iframe
      const iframeWindow = iframe.contentWindow;

      // Imprime el contenido del iframe
      iframeWindow?.print();
    }
  }

  getData(tags: Tag[]): void {
    let params = new HttpParams();
    for (let tag of tags) {
      params = params.append('tags', tag.name);
    }

    const token = localStorage.getItem('token');

    const headers = {
      tags: tags.map((tag) => tag.name),
    };
  }

  search(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.table.search(searchTerm);
  }


  async ngOnInit() {
    this.loadingFull = true;
    await this.getProcedure();
    this.loadingFull = false;
  }

  onEnterPress() {
    return false;
  }

  add(event: MdbChipAddEvent) {
    if (event.value.length > 0 && /\w{2,}/.test(event.value)) {
      this.tags.push({ name: event.value });
      event.input.clear();
    }
  }

  delete(tag: Tag) {
    const index = this.tags.indexOf(tag);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  onProcedureSelected(selectedValue: number) {
    const selectedCompany = this.TipoDocumento.find(
      (company) => company.value === selectedValue
    );
    if (selectedCompany) {
      this.TipoDocumentoId = selectedCompany.value;
    }
  }

  async getProcedure(): Promise<void> {
    this.isLoading = true;

    this.httpClient
      .post<any[]>(environment.apiUrl + '/GetDocumentType', {
        idTipoDocumento: 0,
        idCompany: localStorage.getItem('IdCompany'),
        idApp: localStorage.getItem('appId'),
      })
      .subscribe(
        (data) => {
          // Filter the data to include only items with "PARENT": null
          this.TipoDocumento = data
            .filter((item) => item.PARENT === null)
            .map((item) => ({
              value: item.ID,
              label: item.NOMBRE_TIPO_DOCUMENTO,
              NOMBRE_TIPO_DOCUMENTO: item.NOMBRE_TIPO_DOCUMENTO,
            }));

          this.AllTipoDocumento = data.map((item) => ({
            value: item.ID,
            label: item.NOMBRE_TIPO_DOCUMENTO,
            NOMBRE_TIPO_DOCUMENTO: item.NOMBRE_TIPO_DOCUMENTO,
            PARENT: item.PARENT,
          }));

          // Copy the filtered data to DetalleTipoDocumento as well
          // this.DetalleTipoDocumento = [...this.TipoDocumento];

          // Desactiva isLoading una vez que los datos se han cargado
          this.isLoading = false;
          this.qty = this.TipoDocumento.length;
        },
        (error) => {
          // En caso de error, también debes desactivar isLoading
          this.isLoading = false;
        }
      );
  }

  onChangeTipoDocumentoSelected(selectedValue: number) {
    this.IdDetalleTipoDocumento = selectedValue;
    this.enableButton = true;
  }

  onTipoDocumentoSelected(selectedValue: any) {
    this.idTipoDocumento = selectedValue;
    // se usa el operador coalescente nulo para proporcionar un valor predeterminado si por alguna razon AllTipoDocumento no está definido
    const allTipoDocumento = this.AllTipoDocumento ?? [];

    if (selectedValue !== null && selectedValue !== undefined) {
      // se filtra la data local basado en el selectedValue
      this.DetalleTipoDocumento = allTipoDocumento
        .filter((item) => parseInt(item.PARENT) === parseInt(selectedValue))
        .map((item) => ({
          value: item.value,
          label: item.label,
          NOMBRE_TIPO_DOCUMENTO: item.NOMBRE_TIPO_DOCUMENTO,
        }));

      this.DetalleTipoDocumento.unshift({
        value: -1,
        label: 'TODOS',
        NOMBRE_TIPO_DOCUMENTO: '',
      });
    } else {
      this.DetalleTipoDocumento = [];
    }
  }

  isExternalLinkX(url: string): boolean {
    return url.startsWith('http://') || url.startsWith('https://');
  }

  isExternalLink(url: string): SafeResourceUrl | string {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      return 'assets/pdfs/' + url;
    }
  }

  loadData() {
    const queryParams = {
      tags: this.tags,
      tipoDocumentoId: this.idTipoDocumento !== undefined ? Number(this.idTipoDocumento) : 0,
      detalleTipoDocumentoValue: this.IdDetalleTipoDocumento,
      idCompany: localStorage.getItem('IdCompany'),
      idApp: localStorage.getItem('appId'),
    };

    this.loading = true;
    this.Results = true;
    this.qty = -1;

    this.filas = 0;
    this.busqueda = true;

    this.dataDocumentService
      .getData(environment.apiUrl + environment.documentSearch, queryParams)
      .pipe(take(1))
      .subscribe((data: any[]) => {
        // Procesa los datos y actualiza la dataSource
        this.filas = data.length;
        if (data && data.length > 0) {
          this.dataSource = data.map((dataInfoDoc) => ({
            NOMBRE_DOCUMENTO: dataInfoDoc.NOMBRE_DOCUMENTO,
            CODIGO_DOCUMENTO: dataInfoDoc.CODIGO_DOCUMENTO,
            GERENCIA_DOCUMENTO: dataInfoDoc.GERENCIA_DOCUMENTO,
            NOMBRE_GERENCIA: dataInfoDoc.NOMBRE_GERENCIA,
            PALABRAS_CLAVES: dataInfoDoc.PALABRAS_CLAVES,
            URLDOC: dataInfoDoc.URLDOC,
          }));

          this.Results = false;
          this.qty = data.length;
          this.loading = false;
        } else {
          this.Results = false;
          this.qty = 0;
          this.loading = false;
        }
      });

    return false;
  }

  openModalPDF(data: { URLDOC: string }) {
    const url = this.isExternalLink(data.URLDOC)
      ? data.URLDOC
      : 'assets/pdfs/' + data.URLDOC;
    window.open(url, '_blank');
  }
}
